<noscript>
    <strong translate>We're sorry but NetLinkDeal doesn't work properly without JavaScript enabled. Please enable it to continue.</strong>
</noscript>
<router-outlet>
</router-outlet>